import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { 
  CODE22_REVIEW_LIST,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST,
  CODE22_REVIEW_DETAIL,
  CODE22_REVIEW_SEARCH_PROJECT_LIST,
  CODE22_REVIEW_SEARCH_YEAR_LIST,
  CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST,
  CODE22_REVIEW_SEARCH_DEMAND_LIST
} from '../actions';
import {
  code22_reviewListSuccess,
  code22_reviewListError,
  code22_reviewSearchcode22_reviewGroupListSuccess,
  code22_reviewSearchcode22_reviewGroupListError,
  code22_reviewSearchProjectListSuccess,
  code22_reviewSearchProjectListError,
  code22_reviewSearchYearListSuccess,
  code22_reviewSearchYearListError,
  code22_reviewDetailSuccess,
  code22_reviewDetailError,
  code22_reviewSearchcode22_reviewTypeListSuccess,
  code22_reviewSearchcode22_reviewTypeListError,
  code22_reviewSearchDemandListSuccess,
  code22_reviewSearchDemandListError
} from '../actions';

export function* watchcode22_reviewList() {
  yield takeEvery(CODE22_REVIEW_LIST, oncode22_reviewList);
}

export function* watchcode22_reviewSearchcode22_reviewGroupList() {
  yield takeEvery(CODE22_REVIEW_SEARCH_CODE22_REVIEW_GROUP_LIST, oncode22_reviewSearchcode22_reviewGroupList);
}

export function* watchcode22_reviewDetail() {
  yield takeEvery(CODE22_REVIEW_DETAIL, oncode22_reviewDetail);
}

export function* watchcode22_reviewSearchProjectList() {
  yield takeEvery(CODE22_REVIEW_SEARCH_PROJECT_LIST, oncode22_reviewSearchProjectList);
}

export function* watchcode22_reviewSearchYearList() {
  yield takeEvery(CODE22_REVIEW_SEARCH_YEAR_LIST, oncode22_reviewSearchYearList);
}

export function* watchcode22_reviewSearchcode22_reviewTypeList() {
  yield takeEvery(CODE22_REVIEW_SEARCH_CODE22_REVIEW_TYPE_LIST, oncode22_reviewSearchcode22_reviewTypeList);
}

export function* watchcode22_reviewSearchDemandList() {
  yield takeEvery(CODE22_REVIEW_SEARCH_DEMAND_LIST, oncode22_reviewSearchDemandList);
}

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const oncode22_reviewListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'code22_review/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const oncode22_reviewSearchcode22_reviewGroupListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/code22_review_group', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const oncode22_reviewDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'code22_review/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const oncode22_reviewSearchProjectListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/project', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const oncode22_reviewSearchYearListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/year', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const oncode22_reviewSearchcode22_reviewTypeListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/code22_review_type', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

const oncode22_reviewSearchDemandListAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/demand', {
    method: 'GET', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token }
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return response ;
};

function* oncode22_reviewList(data) {
  try {
    const response = yield call(oncode22_reviewListAsync, data.payload);
    yield put(code22_reviewListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewListError(error));
  }
}

function* oncode22_reviewDetail(data) {
  try {
    const response = yield call(oncode22_reviewDetailAsync, data.payload);
    yield put(code22_reviewDetailSuccess(response.data.data));
  } catch (error) {
    yield put(code22_reviewDetailError(error));
  }
}


function* oncode22_reviewSearchcode22_reviewGroupList(data) {
  try {
    const response = yield call(oncode22_reviewSearchcode22_reviewGroupListAsync, data);
    yield put(code22_reviewSearchcode22_reviewGroupListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewSearchcode22_reviewGroupListError(error));
  }
}

function* oncode22_reviewSearchProjectList(data) {
  try {
    const response = yield call(oncode22_reviewSearchProjectListAsync, data);
    yield put(code22_reviewSearchProjectListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewSearchProjectListError(error));
  }
}

function* oncode22_reviewSearchYearList(data) {
  try {
    const response = yield call(oncode22_reviewSearchYearListAsync, data);
    yield put(code22_reviewSearchYearListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewSearchYearListError(error));
  }
}

function* oncode22_reviewSearchcode22_reviewTypeList(data) {
  try {
    const response = yield call(oncode22_reviewSearchcode22_reviewTypeListAsync, data);
    yield put(code22_reviewSearchcode22_reviewTypeListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewSearchcode22_reviewTypeListError(error));
  }
}

function* oncode22_reviewSearchDemandList(data) {
  try {
    const response = yield call(oncode22_reviewSearchDemandListAsync, data);
    yield put(code22_reviewSearchDemandListSuccess(response.data));
  } catch (error) {
    yield put(code22_reviewSearchDemandListError(error));
  }
}
export default function* rootSaga() {
  yield all([
    fork(watchcode22_reviewList),
    fork(watchcode22_reviewSearchcode22_reviewGroupList),
    fork(watchcode22_reviewSearchProjectList),
    fork(watchcode22_reviewSearchYearList),
    fork(watchcode22_reviewDetail),
    fork(watchcode22_reviewSearchcode22_reviewTypeList),
    fork(watchcode22_reviewSearchDemandList)
  ]);
}